<template>
  <div>
    <footer class="footer">
      <p>
        © 2020-2026 北京温致科技有限公司 
        <br  class="h5-show" />
         <span
          class="clickMouse"
          @click="
            goUrl2(
              'http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010802035193'
            )
          "
        >
          京公网安备 11010802035193号
          <br class="h5-show" /> </span
        > 
        <span class="clickMouse" @click="goUrl2('https://beian.miit.gov.cn/')">
          京ICP备2021009002号
        </span>
      </p>
    </footer>
  </div>
</template>
<script>
export default {
  data() {
    return {
      show: "",
      //判断设备
      // isMobile: navigator.userAgent.match(
      //   /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      // ),
    };
  },
  methods: {
    goUrl(url) {
      if (this.$route.name == url) {
        return;
      } else {
        this.$router.push({ name: url, query: {} });
      }
    },
    goUrl2(url) {
      window.open(url);
    },
  },
};
</script>

<style lang="scss" scoped>
@media all and (min-width: 768px) {
  .h5-show {
    display: none;
  }
  .block {
  }
  .footer {
    height: 6rem;
    background: #0074fc;
    font-weight: 500;
    font-size: 1.1rem;
    color: #ffffff;
    line-height: 6rem;
    text-align: center;
    font-style: normal;
    text-transform: none;
  }
}
@media all and (max-width: 767px) {
  .h5-show {
    // display: block;
  }
  .footer {
    display: flex;
    align-items: center;
    justify-content:  center;
    height: 12rem;
    background: #0074fc;
    font-weight: 500;
    font-size: 1.5rem;
    color: #ffffff;
    line-height: 2.5rem;
    text-align: center;
    font-style: normal;
    text-transform: none;
  }
}
</style>
